export default {"src":"/_next/static/media/linkedin-icon.41ec0d14.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};